import React, { useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import img from '../images/banner.webp';
import logo from '../images/logo_white.webp';
import ContactModal from './ContactModal';
import { useDispatch, useSelector } from 'react-redux';
// import { setToggleTrue } from '../redux/slice/changeState';
import { Link } from 'react-scroll';
import { Row, Col } from 'react-bootstrap';

import {
  setToggleTrue,
  setDownloadBrochureFalse
} from '../redux/slice/changeState';

const Banner = () => {
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
  const [menuOpen, setMenuOpen] = useState(false);
  const dispatch = useDispatch()
  const toggle = useSelector((state) => state.toggle);
  const [navSolid, setNavSolid] = useState(false);

  const handleScroll = () => {
    if (window.scrollY > 75) {
      setNavSolid(true);
    } else {
      setNavSolid(false);
    }
  }

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);


  return (
    <div className="banner" id='overview'>
      <img src="miraclecover.png" className="banner-img" alt="miracle banner" />

      <div className="banner-overlay">
        <div className="nav">
          <div className="banner-logo">
            <img src="Logo.png" alt="logo" />
          </div>

          {isMobile && (
            <div
              className={`hamburger ${menuOpen ? 'open' : ''}`}
              onClick={() => setMenuOpen(!menuOpen)}
            >
              <span></span>
              <span></span>
              <span></span>
            </div>
          )}

          <div className={`banner-menu ${menuOpen ? 'show' : ''} `} >
            <ul>
              <li><Link to="overview" smooth={true} duration={1000}>Overview</Link></li>
              <li><Link to="amenities" smooth={true} duration={1000}>Gallery</Link></li>
              <li><Link to="plans" smooth={true} duration={1000}>Floor Plans</Link></li>
              <li><Link to="price" smooth={true} duration={1000}>Pricing & Availability</Link></li>
              <li><a onClick={() => dispatch(setToggleTrue())}>Contact</a></li>
            </ul>
          </div>

        </div>

        <div className="banner-content">
          <h1 style={{ fontFamily: "Times New Roman" }} className='text-captilize'>
            Ready-to-Move In 3 BHK<br />  Luxury Apartments in Kollur
          </h1>
          <p className='text-capitalize' >
            Luxury living in Kollur, Hyderabad with premium amenities,
            spacious designs and unbeatable pricing starting at ₹6,499/sq. ft.
          </p>

          <div className="banner-buttons">
            <button className="primary-btn" onClick={() => {
              dispatch(setDownloadBrochureFalse());
              dispatch(setToggleTrue());
            }}>Book a Visit</button>

            <a
              href="https://wa.api-whatsapp.in/bglS5n"
              target="_blank"
              rel="noreferrer"
              className="secondary-btn"
            >
              Chat on WhatsApp
            </a>
          </div>

        </div>
        <div className='container mt-5 self-start mx-0 text-light' style={{ maxWidth: "850px" }}>
          <Row className='border border-white'>
            <Col lg={6} md={6} xs={12} className='border-end ps-2 py-2'>
              <p className="small-text">Layout/Building/Permission No.</p>
              <p className='large-text'>File No. 034955/SKP/R1/U6/HMDA/04032020</p>
            </Col>

            <Col lg={6} md={6} xs={12} className='ps-2  py-2'>
              <p className='large-text'>
                TG RERA Registration No. <span>P01100002811</span>
              </p>
              <p className="small-text">
                Website: <a
                  href="https://rera.telangana.gov.in"
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    textDecoration: "none",
                    color: "#fff",
                    cursor: "pointer",
                  }}
                >
                  rera.telangana.gov.in
                </a>
              </p>
            </Col>


          </Row>


        </div>
      </div>
      {
        toggle.hastoggle && <ContactModal />
      }
    </div>
  );
};

export default Banner;
